import styles from "./styles/wave-surfer-player.module.scss";
import Image from "next/image";
import WavePlayerProgress from "@/components/common/music-player/wave-player-progress";
import playSecondaryIcon from "@/assets/music-player/play-secondary.svg";
import stopSecondaryIcon from "@/assets/music-player/stop-secondary.svg";
import Loader from "@/components/common/loader";
import React from "react";
import { useWaveSurfer } from "@/hooks/music-players/use-wave-surfer";

interface WaveSurferPlayerProps {
  url: string;
}

const WaveSurferPlayer = ({ url }: WaveSurferPlayerProps) => {
  const { isItemLoading, isPlaying, togglePlay, ...props } = useWaveSurfer(url);

  return (
    <div className={styles.wrapper}>
      <Image
        className={styles.image}
        src={isPlaying ? stopSecondaryIcon : playSecondaryIcon}
        alt={isPlaying ? "Pause" : "Play"}
        onClick={togglePlay}
        width={32}
        height={32}
      />
      {isItemLoading && <Loader size={"55px"} />}
      <WavePlayerProgress displayTime={false} {...props} />
    </div>
  );
};
export default WaveSurferPlayer;
